'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { Ref } from 'react';
import { useState } from 'react';
import { RecentSearchChips, SearchBar, useHideOnScroll } from '@/app/_components/SearchBar';
const preventBlur = (e: React.MouseEvent) => e.preventDefault();
interface SearchPageHeaderProps {
  keyword: string;
  filterCount: number;
  recentKeywords: string[];
  onSearch: (keyword: string) => void;
  onFilterClick?: () => void;
  onSelectRecent: (keyword: string) => void;
  onRemoveRecent: (keyword: string) => void;
  onClearRecent: () => void;
  ref?: Ref<HTMLDivElement>;
}

/**
 * 모바일: `position: fixed` 오버레이로 상단 고정 + 스크롤 방향에 따라 translate 숨김.
 * PC: 일반 flow. spacer는 mobile-only.
 * ref는 외부 wrapper에 연결되어 IntersectionObserver의 관찰 대상이 된다
 * (모바일에서는 spacer 높이 = in-flow 기준으로 가시성을 판단).
 */
export const SearchPageHeader = t0 => {
  const $ = _c(25);
  const {
    keyword,
    filterCount,
    recentKeywords,
    onSearch,
    onFilterClick,
    onSelectRecent,
    onRemoveRecent,
    onClearRecent,
    ref
  } = t0;
  const [isFocused, setIsFocused] = useState(false);
  const {
    hidden,
    atTop
  } = useHideOnScroll();
  const shouldHide = hidden && !isFocused;
  const shouldHideChipsOnMobile = !isFocused && !atTop;
  const t1 = shouldHide && "mobile-tablet:-translate-y-full";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex w-full flex-col items-center gap-12 bg-Gray-white", "mobile-tablet:fixed mobile-tablet:inset-x-0 mobile-tablet:top-0 mobile-tablet:z-10 mobile-tablet:gap-0", "mobile-tablet:transition-transform mobile-tablet:duration-200", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== filterCount || $[3] !== keyword || $[4] !== onFilterClick || $[5] !== onSearch) {
    t3 = <SearchBar keyword={keyword} filterCount={filterCount} sticky={false} onSearch={onSearch} onFilterClick={onFilterClick} onFocusChange={setIsFocused} />;
    $[2] = filterCount;
    $[3] = keyword;
    $[4] = onFilterClick;
    $[5] = onSearch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onClearRecent || $[8] !== onRemoveRecent || $[9] !== onSelectRecent || $[10] !== recentKeywords || $[11] !== shouldHideChipsOnMobile) {
    t4 = recentKeywords.length > 0 && <div className={cn("w-full overflow-hidden", "mobile-tablet:transition-[max-height] mobile-tablet:duration-200 mobile-tablet:ease-out", shouldHideChipsOnMobile ? "mobile-tablet:max-h-0" : "mobile-tablet:max-h-48")} onMouseDown={preventBlur}><RecentSearchChips keywords={recentKeywords} onSelect={onSelectRecent} onRemove={onRemoveRecent} onClearAll={onClearRecent} /></div>;
    $[7] = onClearRecent;
    $[8] = onRemoveRecent;
    $[9] = onSelectRecent;
    $[10] = recentKeywords;
    $[11] = shouldHideChipsOnMobile;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = recentKeywords.length > 0 && !shouldHideChipsOnMobile ? "mobile-tablet:h-88" : "mobile-tablet:h-48";
  let t7;
  if ($[17] !== t6) {
    t7 = cn("hidden mobile-tablet:block mobile-tablet:transition-[height] mobile-tablet:duration-200", t6);
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = <div aria-hidden={true} className={t7} />;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== ref || $[22] !== t5 || $[23] !== t8) {
    t9 = <div ref={ref} className="w-full flex-1">{t5}{t8}</div>;
    $[21] = ref;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};